import {
  IconBinaryTree2,
  IconBrain,
  IconBuildingSkyscraper,
  IconChartBar,
  IconDashboard,
  IconHeadset,
  IconInbox,
  IconPhone,
  IconRobot,
  IconUsers,
} from '@tabler/icons-react';
import type { LinkProps } from '@tanstack/react-router';

export type NavItem = {
  link: NonNullable<LinkProps['to']>;
  label: string;
  icon: typeof IconDashboard;
};

const dashboardNavLink: NavItem = { link: '/', label: 'Dashboard', icon: IconDashboard };
const flowsNavLink: NavItem = { link: '/flows', label: 'Flows', icon: IconBinaryTree2 };
const personasNavLink: NavItem = { link: '/personas', label: 'Personas', icon: IconRobot };
const phoneNumbersNavLink: NavItem = { link: '/phone-numbers', label: 'Phone Numbers', icon: IconPhone };
const voicemailsNavLink: NavItem = { link: '/voicemails', label: 'Voicemails', icon: IconInbox };
const analyticsNavLink: NavItem = { link: '/analytics', label: 'Analytics', icon: IconChartBar };
const agentWorkspaceNavLink: NavItem = { link: '/agent', label: 'Agent', icon: IconHeadset };

export const systemNavLinks: NavItem[] = [
  { link: '/system/organizations', label: 'Organizations', icon: IconBuildingSkyscraper },
  { link: '/system/super-users', label: 'Super Users', icon: IconUsers },
  { link: '/system/ai-models', label: 'AI Models', icon: IconBrain },
];

export function appNavLinks(hasAiAgent: boolean, hasContactCenter: boolean): NavItem[] {
  return [
    dashboardNavLink,
    flowsNavLink,
    ...(hasAiAgent ? [personasNavLink] : []),
    phoneNumbersNavLink,
    voicemailsNavLink,
    analyticsNavLink,
    ...(hasContactCenter ? [agentWorkspaceNavLink] : []),
  ];
}

export function isNavItemActive(pathname: string, link: string) {
  return pathname === link || (link !== '/' && pathname.startsWith(link));
}
